// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2719%27 height=%2718%27 viewBox=%270 0 19 18%27 fill=%27none%27%3E%3Cpath d=%27M5.73452 15.6995V14.3995V13.8995H6.23452H7.82741L8.58097 13.1459L9.48097 12.2459L9.71227 12.0146L9.92423 11.8027L10.2111 11.8897C10.9434 12.1121 11.7177 12.1598 12.4718 12.029C13.2259 11.8982 13.9389 11.5926 14.5536 11.1367C15.1683 10.6807 15.6677 10.0871 16.0117 9.40344C16.3556 8.71985 16.5347 7.9652 16.5345 7.19996L5.73452 15.6995ZM5.73452 15.6995H3.13452V12.8066L6.81938 9.12174L7.0311 8.91001L6.94441 8.62341C6.7406 7.94967 6.68435 7.23994 6.77947 6.5425C6.8746 5.84507 7.11886 5.17632 7.49565 4.58177C7.87243 3.98722 8.37289 3.48082 8.96296 3.09705C9.55302 2.71327 10.2188 2.46113 10.9151 2.35779C11.6114 2.25444 12.3217 2.30232 12.9978 2.49816C13.6739 2.69399 14.2999 3.0332 14.8331 3.49268C15.3663 3.95216 15.7943 4.52113 16.0879 5.16086C16.3815 5.80049 16.5338 6.49585 16.5345 7.19963L5.73452 15.6995ZM11.6345 3.09948C11.2632 3.09948 10.9071 3.24698 10.6446 3.50953C10.382 3.77208 10.2345 4.12818 10.2345 4.49948C10.2345 4.87078 10.382 5.22688 10.6446 5.48943C10.9071 5.75198 11.2632 5.89948 11.6345 5.89948C11.9793 5.89948 12.31 6.03645 12.5538 6.28024C12.7976 6.52404 12.9345 6.8547 12.9345 7.19948C12.9345 7.57079 13.082 7.92688 13.3446 8.18943C13.6071 8.45198 13.9632 8.59948 14.3345 8.59948C14.7058 8.59948 15.0619 8.45198 15.3245 8.18943C15.587 7.92688 15.7345 7.57078 15.7345 7.19948C15.7345 6.11209 15.3026 5.06924 14.5337 4.30034C13.7648 3.53144 12.7219 3.09948 11.6345 3.09948Z%27 fill=%27%231DB5B6%27 stroke=%27%231DB5B6%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Profile_col__wYUtW {
  padding: 0;
}
.Profile_col__wYUtW:nth-child(1) {
  padding-right: 20px;
}

.Profile_container__WBOt- {
  padding: 0;
  display: grid;
  grid-template-columns: 600px 240px;
  grid-template-rows: min-content;
  gap: 20px;
}
@media (max-width: 1200px) {
  .Profile_container__WBOt- {
    grid-template-columns: 400px 240px;
  }
}
@media (max-width: 1000px) {
  .Profile_container__WBOt- {
    grid-template-rows: min-content min-content;
    grid-template-columns: 100%;
  }
}

.Profile_change_email_text__9sbwK {
  margin-top: 20px;
  color: #899696;
  font-family: Inter;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 19px;
}

.Profile_form_group__k--EJ label {
  color: #575757;
  font-family: Inter;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  margin-bottom: 20px;
}
@media (max-width: 500px) {
  .Profile_form_group__k--EJ input {
    font-size: 12px;
  }
}
@media (max-width: 500px) {
  .Profile_form_group__k--EJ .rs-picker-toggle {
    font-size: 12px;
  }
}

.Profile_password_change__9H3nB {
  color: #1DB5B6;
  font-family: Inter;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  display: flex;
  gap: 5px;
  align-items: center;
  margin-bottom: 15px;
}
.Profile_password_change__9H3nB:before {
  content: "";
  width: 18px;
  height: 18px;
  display: block;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.Profile_change_text__VUseF {
  color: #616E6E;
  font-family: Inter;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}

@media (max-width: 1000px) {
  .Profile_reset__kSreh {
    width: auto;
  }
}

@media (max-width: 1000px) {
  .Profile_profile_form__3NhA\\+ {
    width: 100%;
  }
}
@media (max-width: 500px) {
  .Profile_profile_form__3NhA\\+ .ibox-content {
    padding: 15px 10px;
  }
}

.Profile_title__m4mw- {
  margin-bottom: 12px;
  padding-top: 30px !important;
}`, "",{"version":3,"sources":["webpack://./src/components/Profile/Profile.module.scss"],"names":[],"mappings":"AAAA;EACE,UAAA;AACF;AACE;EACE,mBAAA;AACJ;;AAGA;EACE,UAAA;EACA,aAAA;EACA,kCAAA;EACA,+BAAA;EACA,SAAA;AAAF;AAEE;EAPF;IAQI,kCAAA;EACF;AACF;AACE;EAXF;IAYI,2CAAA;IACA,2BAAA;EAEF;AACF;;AAEA;EACE,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AACF;;AAGE;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AAAJ;AAII;EADF;IAEI,eAAA;EADJ;AACF;AAKI;EADF;IAEI,eAAA;EAFJ;AACF;;AAOA;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,QAAA;EACA,mBAAA;EACA,mBAAA;AAJF;AAME;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,yDAAA;AAJJ;;AAQA;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AALF;;AASE;EADF;IAEI,WAAA;EALF;AACF;;AASE;EADF;IAEI,WAAA;EALF;AACF;AAQI;EADF;IAEI,kBAAA;EALJ;AACF;;AASA;EACE,mBAAA;EACA,4BAAA;AANF","sourcesContent":[".col {\n  padding: 0;\n\n  &:nth-child(1) {\n    padding-right: 20px;\n  }\n}\n\n.container {\n  padding: 0;\n  display: grid;\n  grid-template-columns: 600px 240px;\n  grid-template-rows: min-content;\n  gap: 20px;\n\n  @media (max-width: 1200px) {\n    grid-template-columns: 400px 240px;\n  }\n\n  @media (max-width: 1000px) {\n    grid-template-rows: min-content min-content;\n    grid-template-columns: 100%;\n  }\n\n}\n\n.change_email_text {\n  margin-top: 20px;\n  color: #899696;\n  font-family: Inter;\n  font-size: 13px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 19px;\n}\n\n.form_group {\n  & label {\n    color: #575757;\n    font-family: Inter;\n    font-size: 13px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px;\n    margin-bottom: 20px;\n  }\n\n  & input {\n    @media (max-width: 500px) {\n      font-size: 12px;\n    }\n  }\n\n  :global(.rs-picker-toggle) {\n    @media (max-width: 500px) {\n      font-size: 12px;\n    }\n  }\n\n}\n\n.password_change {\n  color: #1DB5B6;\n  font-family: Inter;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n  display: flex;\n  gap: 5px;\n  align-items: center;\n  margin-bottom: 15px;\n\n  &:before {\n    content: '';\n    width: 18px;\n    height: 18px;\n    display: block;\n    background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='19' height='18' viewBox='0 0 19 18' fill='none'%3E%3Cpath d='M5.73452 15.6995V14.3995V13.8995H6.23452H7.82741L8.58097 13.1459L9.48097 12.2459L9.71227 12.0146L9.92423 11.8027L10.2111 11.8897C10.9434 12.1121 11.7177 12.1598 12.4718 12.029C13.2259 11.8982 13.9389 11.5926 14.5536 11.1367C15.1683 10.6807 15.6677 10.0871 16.0117 9.40344C16.3556 8.71985 16.5347 7.9652 16.5345 7.19996L5.73452 15.6995ZM5.73452 15.6995H3.13452V12.8066L6.81938 9.12174L7.0311 8.91001L6.94441 8.62341C6.7406 7.94967 6.68435 7.23994 6.77947 6.5425C6.8746 5.84507 7.11886 5.17632 7.49565 4.58177C7.87243 3.98722 8.37289 3.48082 8.96296 3.09705C9.55302 2.71327 10.2188 2.46113 10.9151 2.35779C11.6114 2.25444 12.3217 2.30232 12.9978 2.49816C13.6739 2.69399 14.2999 3.0332 14.8331 3.49268C15.3663 3.95216 15.7943 4.52113 16.0879 5.16086C16.3815 5.80049 16.5338 6.49585 16.5345 7.19963L5.73452 15.6995ZM11.6345 3.09948C11.2632 3.09948 10.9071 3.24698 10.6446 3.50953C10.382 3.77208 10.2345 4.12818 10.2345 4.49948C10.2345 4.87078 10.382 5.22688 10.6446 5.48943C10.9071 5.75198 11.2632 5.89948 11.6345 5.89948C11.9793 5.89948 12.31 6.03645 12.5538 6.28024C12.7976 6.52404 12.9345 6.8547 12.9345 7.19948C12.9345 7.57079 13.082 7.92688 13.3446 8.18943C13.6071 8.45198 13.9632 8.59948 14.3345 8.59948C14.7058 8.59948 15.0619 8.45198 15.3245 8.18943C15.587 7.92688 15.7345 7.57078 15.7345 7.19948C15.7345 6.11209 15.3026 5.06924 14.5337 4.30034C13.7648 3.53144 12.7219 3.09948 11.6345 3.09948Z' fill='%231DB5B6' stroke='%231DB5B6'/%3E%3C/svg%3E\");\n  }\n}\n\n.change_text {\n  color: #616E6E;\n  font-family: Inter;\n  font-size: 13px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n}\n\n.reset {\n  @media (max-width: 1000px) {\n    width: auto;\n  }\n}\n\n.profile_form {\n  @media (max-width: 1000px) {\n    width: 100%;\n  }\n\n  :global(.ibox-content) {\n    @media (max-width: 500px) {\n      padding: 15px 10px;\n    }\n  }\n}\n\n.title {\n  margin-bottom: 12px;\n  padding-top: 30px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"col": `Profile_col__wYUtW`,
	"container": `Profile_container__WBOt-`,
	"change_email_text": `Profile_change_email_text__9sbwK`,
	"form_group": `Profile_form_group__k--EJ`,
	"password_change": `Profile_password_change__9H3nB`,
	"change_text": `Profile_change_text__VUseF`,
	"reset": `Profile_reset__kSreh`,
	"profile_form": `Profile_profile_form__3NhA+`,
	"title": `Profile_title__m4mw-`
};
export default ___CSS_LOADER_EXPORT___;
